// Временно жестко задайте URL
export const API_URL = 'https://lghrequests.com';
export const SOCKET_URL = 'https://lghrequests.com';